import routePath from '@src/lib/routePath'

const root = `/retailer/industry-content/:retailerAccountSlug/all`
const base = `/retailer/industry-content/:retailerAccountSlug/all/:activeTab?`

const industryContentPaths = {
  root: routePath(root),
  index: routePath(base),
  activatePaidCampaign: routePath(`${base}/paid-ad/:campaignId` as const),
}

export default industryContentPaths
